module.exports = __webpack_public_path__ + "static/media/Jaheen.8ef703e2.JPG";